//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectBodyList.js";
import "../no/SelectFace.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"Blank",0,"Assemblies.SelectComponent",0],[0,"BlankMatrix",1,0],[1,"BlendRadius",0,"Expression",0],[0,"CrossLinesRatio",1,0],[1,"ExtensionHeight",0,"Expression",0],[1,"HeadBodies",0,"SelectBodyList",0],[1,"JointFace",0,"SelectFace",0],[0,"JointMethod",1,0],[0,"KeepSize",1,0],[0,"KeepZValueInSameMSet",1,0],[0,"Material",1,0],[0,"MsetPart",1,"TaggedObject",0],[0,"MultiPositionBuilder",1,"TaggedObject",0],[0,"ReferenceCenter",1,0],[0,"ReferencePointPrecision",1,0],[0,"Rename",1,0],[0,"ReusablePartBuilder",1,"TaggedObject",0],[1,"RotationAngle",0,"Expression",0],[0,"RoundCrossLinesPosition",1,0],[0,"Shape",1,0],[0,"UniteBodies",1,0],[1,"XRefValue",0,"Expression",0],[1,"YRefValue",0,"Expression",0],[1,"ZRefValue",0,"Expression",0]],[[["registerPath","dataPath","modelPath","bitmapPath","material","paraNames","paraValues"],"UpdateBlankData",{},7,0],[["applicationType","installationMethod","partToBeInstalled","folderToSaveParts","projectName"],"CreateCloneObject",{R_:{cloneObject:"Tooling.CloneObject"}},5,0],[["displayName"],"UpdateDisplayName",{},1,0]],[]];
SPLM.Tooling.ElectrodeBlankBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ElectrodeBlankBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ElectrodeBlankBuilder.BlankShape = Object.freeze({
    "Block" : "Block", "Cylinder" : "Cylinder", "Undercut" : "Undercut"});

SPLM.Tooling.ElectrodeBlankBuilder.BlankMaterial = Object.freeze({
    "Copper" : "Copper", "Graphite" : "Graphite"});

SPLM.Tooling.ElectrodeBlankBuilder.JointObject = Object.freeze({
    "Extrude" : "Extrude", "Offset" : "Offset", "None" : "None"});

export default SPLM;